import assign from './assign';
import review from './review';
import total from './total';

export default {
    assign,
    review,
    total
}